<div *ngIf="showLine" class="{{siteId}} horizontal-separator"></div>
<div id="footerWrapper"
    class="syndicated-footer-wrapper"
    [@footerState]="stateName"
    (@footerState.done)="footerStateDone($event)">
    <app-script-loader [src]="syndicatedFooterUrl"></app-script-loader>
</div>
